export default "__VITE_ASSET__FATVY0xl__"